import React, { useContext, useState } from "react";
import { FaQrcode } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../../api";
import Button from "../../components/Button";
import Header from "../../components/Header";
import InputField from "../../components/InputField";
import { LoaderContext } from "../../context/LoaderContext";
import {
  StyledAuthLogoContainer,
  StyledMainContainer,
} from "../../styles/global";
import { StyledForgotPasswordCard } from "./styled";

interface Props {}

const ForgotPassword: React.FC<Props> = () => {
  const [email, setEmail] = useState("");
  const { showLoader } = useContext(LoaderContext);

  const sendForgotPasswordLink = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    showLoader({
      show: true,
    });
    await api
      .ForgotPassword(email)
      .then((res) => {
        if (res.status === 200) {
          showLoader({
            show: false,
          });
          toast.success(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            "Something went wrong! please try again later."
        );
      })
      .finally(() => {
        setEmail("");
        showLoader({
          show: false,
        });
      });
  };

  return (
    <>
      <Header title="WhatQR" />
      <StyledMainContainer onClick={() => {}}>
        <StyledAuthLogoContainer>
          <FaQrcode />
        </StyledAuthLogoContainer>
        <StyledForgotPasswordCard>
          <InputField
            name="email"
            placeholder="Enter your email"
            label="Email"
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />

          <Button
            onClick={(e) => {
              sendForgotPasswordLink(e);
            }}
            label="Send Email"
          />
        </StyledForgotPasswordCard>
      </StyledMainContainer>
    </>
  );
};

export default ForgotPassword;
